<template>
  <div>
    <el-form size="small">
      <el-row :gutter="15">
        <el-col :span="12">
          <DateForm
            ref="dateForm"
          />
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col>
        <el-button
          type="primary"
          size="small"
          class="float-right"
          @click.native="downloadCSV()"
        >
          Generate Report
        </el-button>
      </el-col>
    </el-row>
    <Preview
      v-if="isShowPreview"
      title="Invoice Summary Report"
      :is-show.sync="isShowPreview"
      :is-direct-download="true"
      :configuration="configuration"
    />
  </div>
</template>

<script>
import DateForm from '@/components/Application/Reports/DateForm'
import Preview from '@/components/Application/Reports/Preview'

export default {
  components: {
    DateForm,
    Preview
  },
  data () {
    return {
      breadcrumb: {
        name: 'MyobExport',
        route: { name: 'reports-invoice-myob' }
      },
      account: {},
      form: {
        dateFrom: null,
        dateTo: null
      },
      formTem: null,
      reportType: false,
      isShowPreview: false,
      configuration: null
    }
  },
  methods: {
    setDate (date) {
      this.form.dateFrom = this.$moment(date[0]).format('YYYY-MM-DD HH:mm:ss')
      this.form.dateTo = this.$moment(date[1]).format('YYYY-MM-DD HH:mm:ss')
    },
    downloadCSV () {
      this.$refs.dateForm.$refs.form.validate(async valid => {
        if (valid) {
          this.setDate(this.$refs.dateForm.form.value)

          this.formTem = this.form

          this.clean(this.formTem)

          let _pathname = 'Myob'

          this.configuration = {
            report: _pathname,
            params: this.form
          }
          this.isShowPreview = true
        }
      })
    },
    clean (obj) {
      var propNames = Object.getOwnPropertyNames(obj)
      for (var i = 0; i < propNames.length; i++) {
        var propName = propNames[i]
        if (obj[propName] === null || obj[propName] === undefined) {
          delete obj[propName]
        }
      }
    }
  }
}
</script>

<style>

</style>
